import { Filters } from 'react-data-grid-addons';
import {
  BoldFormatter,
  RoundingFormatter,
  PercentFormatter,
} from './StatsTableFormatters';

export const defaultColumnProperties = {
  filterable: true,
  sortable: true,
  width: 160,
};

export const defaultNumericColumnProperties = {
  width: 120,
};

const ignoreColumns = [];

const impactColumns = [
  'total_games',
  'total_factored_points_poss',
  'total_factored_opp_points_poss',
  'total_factored_net_rating',
  'pp40',
  'efg',
  'opp_efg',
  'tov',
  'opp_tov',
  'orr',
  'opp_orr',
  'ftr',
  'opp_ftr',
  'atr_rate',
  'opp_atr_rate',
  'atr_percentage',
  'opp_atr_percentage',
  'three_rate',
  'opp_three_rate',
  'three_percentage',
  'opp_three_percentage',
  'mid_rate',
  'opp_mid_rate',
  'mid_percentage',
  'opp_mid_percentage',
  'pps',
  'opp_pps',
  'pps_noft',
  'opp_pps_noft',
  'true_shooting',
  'opp_true_shooting',
  'fg_perc',
  'opp_fg_perc',
  'fg2_perc',
  'opp_fg2_perc',
  'ft_perc',
  'opp_ft_perc',
  'assist_percentage',
  'opp_assist_percentage',
  'ato',
  'opp_ato',
];

const translations = {
  total_games: 'GMS',
  total_factored_points_poss: 'ORTG',
  total_factored_opp_points_poss: 'ORTG',
  total_factored_net_rating: 'NET',
  pp40: 'PACE',
  efg: 'EFG',
  tov: 'TOV',
  orr: 'ORR',
  ftr: 'FTR',
  atr_rate: 'ATRAR',
  atr_percentage: 'ATR%',
  three_rate: '3PAR',
  three_percentage: '3FG%',
  mid_rate: 'MIDAR',
  mid_percentage: 'MID%',
  pps: 'PPS+FT',
  pps_noft: 'PPS',
  true_shooting: 'TS%',
  fg_perc: 'FG%',
  fg2_perc: '2FG%',
  ft_perc: 'FT%',
  assist_percentage: 'AST%',
  ato: 'ATO',
  opp_efg: 'EFG',
  opp_tov: 'TOV',
  opp_orr: 'ORR',
  opp_ftr: 'FTR',
  opp_atr_rate: 'ATRAR',
  opp_atr_percentage: 'ATR%',
  opp_three_rate: '3PAR',
  opp_three_percentage: '3FG%',
  opp_mid_rate: 'MIDAR',
  opp_mid_percentage: 'MID%',
  opp_pps: 'PPS+FT',
  opp_pps_noft: 'PPS',
  opp_true_shooting: 'TS%',
  opp_fg_perc: 'FG%',
  opp_fg2_perc: '2FG%',
  opp_ft_perc: 'FT%',
  opp_assist_percentage: 'AST%',
  opp_ato: 'ATO',
};

const formatColumn = column => {
  const isOpp = column.includes('opp');
  let stripped = isOpp ? column.replace('opp_', '') : column;
  let formatted = translations[stripped] || stripped.replace('_', ' ');
  if (isOpp) formatted = `Opp. ${formatted}`;
  return formatted;
};

export const columns = [
  {
    name: 'Team',
    key: 'name',
    filterable: true,
    width: 240,
    frozen: true,
    formatter: BoldFormatter,
  },
  {
    name: 'Rank',
    key: 'rank',
    filterable: false,
    width: 80,
    frozen: true,
    formatter: BoldFormatter,
  },
  {
    name: 'Division',
    key: 'division',
    filterable: true,
    filterRenderer: Filters.AutoCompleteFilter,
  },
  {
    name: 'Conference',
    key: 'conference',
    filterable: true,
    filterRenderer: Filters.AutoCompleteFilter,
  },
  ...impactColumns
    .filter(column => !ignoreColumns.includes(column))
    .map(column => ({
      name: formatColumn(column),
      key: column,
      filterable: true,
      filterRenderer: Filters.NumericFilter,
      formatter:
        column.indexOf('perc') > -1 ? PercentFormatter : RoundingFormatter,
      ...defaultNumericColumnProperties,
    })),
].map(column => ({
  ...defaultColumnProperties,
  ...column,
}));
